class Summary {
    /**
     * Constructor
     */
    constructor() {
        /**
         * @type {{}}
         */
        this.gameData = {};
        /**
         * @type {Element | string}
         */
        this.dataGameID = document.querySelector('[data-game-id]') && document.querySelector('[data-game-id]').getAttribute('data-game-id');
        /**
         * @type {NodeListOf<Element>}
         */
        this.donuts = document.querySelectorAll('.donut-container');
        /**
         * @type {NodeListOf<Element>}
         */
        this.percentList = document.querySelector('.table-percent ul');
        /**
         * @type {NodeListOf<Element>}
         */
        this.percentListItem = this.percentList && this.percentList.querySelectorAll('li');
        /**
         * @type {boolean}
         */
        this.isSingleSummary = !this.percentList;
        /**
         * _init
         */
        this._init();
    }

    /**
     * Init
     * @private
     */
    _init() {
        this._getGameData();
    }

    /**
     * Get game data
     * @private
     */
    _getGameData() {
        // Get game data
        GameAsync.get().then((response) => {
            this.gameData = JSON.parse(response);
            this._onDataReady();
        }).catch((e) => {
            console.log(e);
        });
    }

    /**
     * On data ready
     * @private
     */
    _onDataReady() {
        // Browse game
        for (let i = 0; i < 6; i++) {
            const PERCENT = (this.gameData[i + 1] && this.gameData[i + 1].scorePercent) ? this.gameData[i + 1].scorePercent : 0;

            // Set percent list item
            if (!this.isSingleSummary) {
                this.percentListItem[i].querySelector('.percent-item-list').innerText = PERCENT + '%';
            }

            // Set donut top percent
            new Donut(this.donuts[i], PERCENT);
        }

        // If final summary
        if (!this.isSingleSummary) {
            this.sortList(this.percentList);

            // Set title
            let titlePrimary = '';
            let titleSecondary = '';

            if (this.gameData.all.scorePercent >= 75) {
                titlePrimary = 'Excellent,';
                titleSecondary = ' et si vous témoigniez ?';
            } else if (this.gameData.all.scorePercent >= 60) {
                titlePrimary = 'Un engagement de qualité,';
                titleSecondary = 'en route vers l’excellence';
            } else if (this.gameData.all.scorePercent >= 30) {
                titlePrimary = 'Une démarche en cours de construction,';
                titleSecondary = 'on vous donne un coup de pouce...';
            } else {
                titlePrimary = 'Lancez-vous';
                titleSecondary = 'et découvrez les actions à mettre en place !';
            }

            document.getElementById('primary-title').innerText = titlePrimary;
            document.getElementById('secondary-title').innerText = titleSecondary;
        }

        // Total percent
        const TEXT_PERCENT = document.getElementsByClassName('full-percent')[0];

        // Set total or percent or category percent
        TEXT_PERCENT.textContent = this.gameData.all.scorePercent;

        // OLD : DISPLAY PERCENT CURRENT GAME ID
        // if (this.dataGameID) {
        //     TEXT_PERCENT.textContent = this.gameData[parseInt(this.dataGameID)].scorePercent;
        // } else {
        //     // Set donut total percent
        //     TEXT_PERCENT.textContent = this.gameData.all.scorePercent;
        // }
    }

    /**
     * Sort list
     * @param ul
     */
    sortList(ul) {
        let new_ul = ul.cloneNode(false);

        // Add all lis to an array
        let lis = [];
        for (let i = ul.childNodes.length; i--;) {
            if (ul.childNodes[i].nodeName === 'LI')
                lis.push(ul.childNodes[i]);
        }

        // Sort the lis in descending order
        lis.sort(function (a, b) {
            return parseInt(a.querySelector('.percent-item-list').innerText, 10) - parseInt(b.querySelector('.percent-item-list').innerText, 10);
        });

        // Add them into the ul in order
        for (let i = 0; i < lis.length; i++)
            new_ul.appendChild(lis[i]);
        ul.parentNode.replaceChild(new_ul, ul);
    }
}
